import AddQuestion from './AddQuestion';

export default AddQuestion;
